import { render, staticRenderFns } from "./TeamStatComponent.vue?vue&type=template&id=aa94f610&"
import script from "./TeamStatComponent.vue?vue&type=script&lang=js&"
export * from "./TeamStatComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeamStatComponent.vue?vue&type=style&index=0&id=aa94f610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports